import { Link } from "react-router-dom"
import {
  formatAwakenProgress,
  formatDailyActiveTime,
  hasPetNotificationBadge,
  petAccentSurface,
  preAwakenPassiveHint,
  resolvePetAccentColor,
  resolvePetElementFromPassport,
} from "@/constants/petInfo"
import { DigitalPassport } from "@/types/battle"

export default function PetActiveTimeWidget({
  passport,
}: {
  passport: DigitalPassport
}) {
  const activeTime = passport.activeTime
  const canAwaken = passport.canAwakenPet ?? activeTime?.canAwaken ?? false
  const spiritAwakened =
    passport.spiritAwakened ?? activeTime?.spiritAwakened ?? false
  const showBadge = hasPetNotificationBadge(canAwaken, passport.pet ?? null)

  if (!activeTime && !passport.pet && !canAwaken && !spiritAwakened) return null

  const petElement = resolvePetElementFromPassport(passport)
  const accentColor = resolvePetAccentColor(petElement)
  const surface = petAccentSurface(petElement)
  const mult = passport.preAwakenPassiveMult ?? 1
  const hint = !spiritAwakened
    ? preAwakenPassiveHint(mult, activeTime ?? undefined)
    : null

  return (
    <Link
      to="/play/pet"
      className="flex w-full flex-row items-center gap-3 rounded-[14px] border p-3.5"
      style={{
        borderColor: surface.borderColor,
        backgroundColor: surface.backgroundColor,
      }}
    >
      <div className="relative">
        <span style={{ color: accentColor, fontSize: 22 }}>🐾</span>
        {showBadge ? (
          <span className="absolute -right-1 -top-0.5 h-2.5 w-2.5 rounded-full border border-guardians-bg bg-red-500" />
        ) : null}
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[15px] font-bold text-white">Дух-питомец</div>
        {spiritAwakened && passport.pet ? (
          <p className="text-sm text-white/80">
            {passport.pet.displayName} · ур. {passport.pet.level}
          </p>
        ) : canAwaken ? (
          <p className="text-sm font-semibold text-guardians-accent">
            Готов к пробуждению!
          </p>
        ) : activeTime ? (
          <>
            <p className="text-sm text-white/80">{formatAwakenProgress(activeTime)}</p>
            <p className="text-xs text-white/45">{formatDailyActiveTime(activeTime)}</p>
          </>
        ) : null}
        {hint ? <p className="mt-1 text-[11px] text-white/45">{hint}</p> : null}
      </div>
      <span className="text-lg text-white/35">›</span>
    </Link>
  )
}
